import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "product-mutations"
    }}>{`Product mutations`}</h1>
    <p>{`The product mutations allow you to perform the following operations:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Manage comparison lists`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "add-products-to-compare-list.md"
            }}><inlineCode parentName="a">{`addProductsToCompareList`}</inlineCode></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "assign-compare-list.md"
            }}><inlineCode parentName="a">{`assignCompareListToCustomer`}</inlineCode></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "create-compare-list.md"
            }}><inlineCode parentName="a">{`createCompareList`}</inlineCode></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "delete-compare-list.md"
            }}><inlineCode parentName="a">{`deleteCompareList`}</inlineCode></a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "remove-from-compare-list.md"
            }}><inlineCode parentName="a">{`removeProductsFromCompareList`}</inlineCode></a></li>
        </ul>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Create a product review`}</p>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "create-review.md"
            }}><inlineCode parentName="a">{`createProductReview`}</inlineCode></a></li>
        </ul>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      